import { projectListType } from '@app/models/environment.model';

export type paymentResultType = {
  result: 'success' | 'errorLugas' | 'error' | 'errorcode';
  desc: string;
};

export type paymentResultBankType = {
  code: 'success' | 'errorLugas' | 'error' | 'errorcode';
  description: string;
  message: string;
};

export type paymentResultPay3000Type = {
  Status: 'true' | 'false';
  desc: string;
  ErrorMessage: string;
};

export type depositConfigItemType = {
  id: number;
  paymentMethod: () => Promise<any>;
  resultType: (i: any, x: any) => { success: boolean; message: string; finished: boolean };
  description: string;
  paymentMethodId?: string;
  isSkipAmount?: boolean;
  isLugasControl?: boolean;
  iconName: string;
};

export type depositConfigType = {
  [key: string]: {
    [key: string]: depositConfigItemType;
  };
};

type AdditionalInfo = 'coin_address' | 'email_address' | 'de_phoneNumber' | 'bankList' | 'de_accountNo' | 'nameSurname' | '';
export type withdrawConfigItemType = {
  id: number;
  paymentMethod: (props?: any) => Promise<any>;
  resultType: (i: any, x: any) => { success: boolean; message: string; finished: boolean };
  description: string;
  additionalInfo?: AdditionalInfo[];
  paymentMethodId?: string;
  iconName: string;
};

export type withdrawConfigType = {
  [key: string]: {
    [key: string]: withdrawConfigItemType;
  };
};
